import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Home';
import Empatea from './Empatea';
import Cartilha from './Cartilha';

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/empatea" element={<Empatea />} />
                <Route path="/cartilha" element={<Cartilha />} />
            </Routes>
        </Router>
    );
}

export default App;